export interface PolarFigureSpec {
  id: 'circle' | 'rose-3' | 'cardioid' | 'limacon';
  params?: Record<string, number>;
}

function radius(spec: PolarFigureSpec, theta: number): number {
  switch (spec.id) {
    case 'circle':
      return spec.params?.r ?? 1;
    case 'rose-3':
      return Math.sin(3 * theta);
    case 'cardioid':
      return 1 + Math.cos(theta);
    case 'limacon':
      return 1 - 2 * Math.cos(theta);
  }
}

export function samplePolar(spec: PolarFigureSpec, samples = 240): Array<{ x: number; y: number }> {
  const n = Math.max(2, samples);
  const points: Array<{ x: number; y: number }> = [];
  for (let i = 0; i < n; i++) {
    const theta = (i / (n - 1)) * 2 * Math.PI;
    const r = radius(spec, theta);
    points.push({ x: r * Math.cos(theta), y: r * Math.sin(theta) });
  }
  return points;
}
